import classNames from 'classnames';

import { useThemeClassName } from '../../contexts/ThemeContext';
import UserLetter from './UserLetter';

import styles from '../../../styles/partials/user-banner.module.scss';

interface UserBannerProps {
    user: User;
    points?: number;
    prefix?: Element | string;
    pointsLabel?: string;
    className?: string;
}

function UserBanner({
    user = null,
    points = null,
    prefix = null,
    pointsLabel = 'points',
    className = null,
}: UserBannerProps) {
    const themeClassName = useThemeClassName(styles);
    return (
        <div
            className={classNames([
                styles.container,
                {
                    [themeClassName]: themeClassName !== null,
                    [className]: className !== null,
                },
            ])}
        >
            <div className={styles.inner}>
                <UserLetter className={styles.letter} user={user} withName />
                {points !== null ? (
                    <div className={styles.points}>
                        {prefix ? <span className={styles.light}>{prefix} </span> : null}
                        {points} {pointsLabel}
                    </div>
                ) : (
                    <div className={styles.points} />
                )}
            </div>
        </div>
    );
}

export default UserBanner;
